import OpenData from 'screens/OpenData/OpenData';

export default OpenData;
